import { Component, inject, OnInit } from '@angular/core';
import { RouteDaysComponent } from './shared/route-days/route-days.component';
import { PlannerViewsStateService } from './services/planner-views-state.service';
import { EditRouteComponent } from "./components/edit-route/edit-route.component";
import { RouteTimelineComponent } from "./components/route-timeline/route-timeline.component";
import { BuyTicketsComponent } from './components/buy-tickets/buy-tickets.component';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { CUSTOM_ROUTE_MOBILE_MAP } from '../../components/custom-route-mobile/config/constants';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { RouteDayComponent } from "./shared/route-day/route-day.component";
import { EditRouteService } from './components/edit-route/services';

@Component({
  selector: 'app-planner',
  standalone: true,
  imports: [
    RouteDaysComponent,
    EditRouteComponent,
    RouteTimelineComponent,
    BuyTicketsComponent,
    RouteDayComponent
],
  templateUrl: './planner.component.html',
  styleUrls: ['./planner.component.scss'],
})
export class PlannerComponent implements OnInit {
  private _plannerViewsStateService = inject(PlannerViewsStateService);
  private _sessionStorageService = inject(SessionStorageService);
  private _breakpointsService = inject(BreakpointsService);
  private _editRouteService = inject(EditRouteService);
  
  protected isEditRouteView = this._plannerViewsStateService.isEditRouteView;
  protected isBuyTicketsView = this._plannerViewsStateService.isBuyTicketsView;
  
  ngOnInit(): void {
    if (this._breakpointsService.isMobile()) {
      this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.planner);
    }
  }
  
  ngOnDestroy(): void {
    this._editRouteService.cancelSuggestedPointsRequests();
  }
}
